<template>
  <div class="order-action-sidebar">
    <order-agent-notes :order="order" />
    <project-information :order="order">
      <v-card-text>
        <qtm-input-label density="compact" label="CS Agent">
          <order-agent-select :order="order" />
        </qtm-input-label>
      </v-card-text>
    </project-information>
  </div>
</template>

<script setup lang="ts">
import type { Order } from '@quotetome/materials-api'
import ProjectInformation from '@/components/admin/project-information.vue'
import OrderAgentSelect from '@/components/admin/order-agent-select.vue'
import OrderAgentNotes from '@/components/admin/order-agent-notes.vue'

export interface Props {
  order: Order
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.order-action-sidebar > * {
  margin-bottom: 1rem;
}
</style>
